import { ArrowUpRight } from "lucide-react";

const PARTNERS = [
  {
    id: "consultancy",
    name: "Winhouse Consultancy",
    logo: "/partner-winhouse-consultancy.jpg",
    logoWebp: "/partner-winhouse-consultancy.webp",
    url: "https://winhousetutors.com",
    ctaLabel: "Visit Winhouse Tutors",
  },
  {
    id: "academy",
    name: "Winhouse Academy",
    logo: "/partner-winhouse-academy.jpg",
    logoWebp: "/partner-winhouse-academy.webp",
    url: "https://winhousetutors.academy",
    ctaLabel: "Visit Winhouse Academy",
  },
];

export default function PartnerSection() {
  return (
    <section
      id="partner"
      data-testid="partner-section"
      className="relative py-20 md:py-28 px-6 md:px-12 lg:px-20 bg-[#0B0B0B] border-t border-[#1a1a1a]"
    >
      <div className="max-w-6xl mx-auto">
        {/* Section header */}
        <div className="text-center reveal mb-14 md:mb-16">
          <span
            data-testid="partner-overline"
            className="text-[11px] tracking-[0.42em] uppercase text-[#D4AF37]"
          >
            Supported by Our Trusted Partners
          </span>
          <h3 className="mt-5 font-serif-display text-[26px] sm:text-3xl md:text-[36px] leading-[1.2] tracking-tight text-white max-w-2xl mx-auto">
            In partnership with{" "}
            <span className="italic text-gold-shimmer">Winhouse.</span>
          </h3>
          <p className="mt-5 text-[14px] md:text-[15px] leading-[1.9] text-white/60 font-light max-w-2xl mx-auto">
            Trusted partners supporting our mission to empower artisans and
            preserve cultural craftsmanship through sustainable opportunities.
          </p>
        </div>

        {/* Partners grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#1a1a1a] border border-[#1a1a1a]">
          {PARTNERS.map((p, i) => (
            <div
              key={p.id}
              data-testid={`partner-card-${p.id}`}
              className="bg-[#0B0B0B] px-8 py-12 md:py-16 flex flex-col items-center text-center reveal"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              {/* Logo on cream plaque so white-bg source logo sits naturally on the dark section */}
              <a
                href={p.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Visit ${p.name}`}
                onClick={() =>
                  typeof window !== "undefined" &&
                  window.trackPartner &&
                  window.trackPartner(p.name, p.url, { placement: "logo" })
                }
                data-testid={`partner-logo-link-${p.id}`}
                className="block mb-8 group"
              >
                <div className="bg-[#f7f5ef] border border-[#D4AF37]/30 group-hover:border-[#D4AF37] transition-all duration-500 p-5 md:p-6 w-[220px] md:w-[240px] aspect-square flex items-center justify-center mx-auto">
                  <picture>
                    <source type="image/webp" srcSet={p.logoWebp} />
                    <img
                      src={p.logo}
                      alt={p.name}
                      loading="lazy"
                      width="900"
                      height="429"
                      className="max-h-full max-w-full w-auto h-auto object-contain transition-transform duration-500 group-hover:scale-[1.03]"
                    />
                  </picture>
                </div>
              </a>

              {/* Name */}
              <p className="text-[11px] tracking-[0.42em] uppercase text-[#D4AF37] mb-5">
                {p.name}
              </p>

              {/* CTA */}
              <a
                href={p.url}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() =>
                  typeof window !== "undefined" &&
                  window.trackPartner &&
                  window.trackPartner(p.name, p.url, { placement: "button" })
                }
                data-testid={`partner-visit-btn-${p.id}`}
                className="inline-flex items-center gap-2 border border-[#D4AF37]/40 hover:border-[#D4AF37] text-[11px] tracking-[0.22em] uppercase text-[#D4AF37] px-5 py-3 hover:bg-[#D4AF37]/5 transition-all duration-400"
              >
                <span>{p.ctaLabel}</span>
                <ArrowUpRight className="w-3.5 h-3.5" />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
